import * as z from "zod";

       // eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createOrganizationSchema = (t: any) => {
  return z.object({
    name: z
      .string()
      .min(2, t("auth.onboarding.validation.nameMinLength"))
      .max(100, t("auth.onboarding.validation.nameMaxLength")),
    info: z
      .string()
      .min(1, t("auth.onboarding.validation.infoRequired")),
    industry: z
      .string()
      .min(2, t("auth.onboarding.validation.industryMinLength"))
      .max(100, t("auth.onboarding.validation.industryMaxLength")),
    size: z
      .string()
      .min(1, t("auth.onboarding.validation.sizeRequired")),
    stage: z
      .string()
      .min(1, t("auth.onboarding.validation.stageRequired")),
    website: z
      .string()
      .min(1, t("auth.onboarding.validation.websiteRequired"))
      .url(t("auth.onboarding.validation.websiteInvalid")),
  });
};
